import { needsToMoveOutOfSea } from "./game";
import { relatives } from "./property";
import propertyState from "./propertyState";

export default interface playerState {

  properties: propertyState[];
  bankBalance: number;

  round: number; //Which round we're on
  roundState: number; //What state we're in the round

  stopBank: boolean;

  //Notifications for when things are destroyed in a round
  stopBankDestroyed: boolean;
  cowshedDestroyed: boolean;
  natureBasedSeaDestroyed: boolean;
  seaWallDestroyedHeight: number;

  isMakingNatureBasedSolution: boolean;
  natureBasedState: number;
  livedInProperty: string;

  natureBasedSeaSolution: boolean;

  seaWallHeight: number;
  seaWallRound: number;

  playerRPC: { [id: string]: playerRPC }
  lastSeen: number;
  isOverdue: boolean;

  roundActions: { [id: string]: boolean }[] | null;

  //similar to roundActions, but contains EVERY action the player did
  roundAnalytics: string[][] | null;

  //More or less just to display on calendar
  display_income: number;
  display_rent: number;
  display_repair: number;

  //Analytics
  round_bankbalance: number[];
  round_property: string[];
  round_propertyvalue: number[];

}

export enum playerRPCType {
  AskForStopBankVote,
  AskForNatureBasedVote,
  StopBankVoteFinished,
  NatureBasedVoteFinished,
  Donate
}

export class playerRPC {
  RPCType: playerRPCType;
  Value: any;

  constructor(type: playerRPCType, value: any) {
    this.RPCType = type;
    this.Value = value;
  }
}

export function isLivingWithRelatives(playerState: playerState): boolean {
  return playerState.livedInProperty == relatives.key;
}

export function doPlayerAction(playerState: playerState, actionKey: string, analyticsText: string, maxRounds: number): void {

  //Ensure the action key is valid for saving to firebase
  if (actionKey) {

    actionKey = actionKey.replace(".", "").replace("$", "").replace("#", "").replace("[", "").replace("]", "").replace("/", "").replace(">", "");

    //For the end of round report
    if (!playerState.roundActions) {
      playerState.roundActions = new Array(maxRounds + 1);
    }
    if (!playerState.roundActions[playerState.round]) {
      playerState.roundActions[playerState.round] = {};
    }
    playerState.roundActions[playerState.round][actionKey] = true;

  }

  //No analytics to post
  if (analyticsText) {

    //Analytics
    if (!playerState.roundAnalytics) {
      playerState.roundAnalytics = new Array(maxRounds + 1);
    }
    if (!playerState.roundAnalytics[playerState.round]) {
      playerState.roundAnalytics[playerState.round] = [];
    }
    playerState.roundAnalytics[playerState.round].push(analyticsText);

  }

}

//Get the round report, including whether they did nothing or not
export function getRoundReport(playerState: playerState, T: (id: string) => string, round: number, prefix: string = ""): string[] {

  const result: string[] = [];

  let forcedToMove = needsToMoveOutOfSea(playerState, true);

  if (!playerState.roundActions
    || !playerState.roundActions[round]
    || Object.keys(playerState.roundActions[round]).length == 0) {

    if (forcedToMove) {
      result.push(prefix + T("forced_city_move_report"));
    }
    else if (playerState.isOverdue) {

      if (playerState.bankBalance >= getRepairCost(playerState)) {
        //We have enough money so we're forced to pay for repair this round
        result.push(prefix + T("action_nothing_forced_repair"));
      }
      else {
        //We can't afford to pay for repair this round
        result.push(prefix + T("action_nothing_repair"));
      }
    }
    else {
      result.push(prefix + T("action_nothing"));
    }

  }
  else {

    for (const key of Object.keys(playerState.roundActions[round])) {
      result.push(prefix + key);
    }

    //were we also forced to move this round?
    if (forcedToMove) {
      result.push(prefix + T("forced_city_move_report"));
    }
  }

  return result;
}

export function getRepairCost(playerState: playerState): number {

  let result = 0;

  for (const propertyState of playerState.properties) {

    for (let i = 0; i < propertyState.propertyPartStates.length; i++) {
      const propertyPartState = propertyState.propertyPartStates[i];
      if (propertyPartState.repairCost) {
        result += propertyPartState.repairCost;
      }
    }

  }

  return result;

}
